import { createSelector } from 'reselect';

export const staffState = (state) => state.staff;

export const getStaff = createSelector(staffState, ({ staff }) => staff);
export const getLocation = createSelector(
  staffState,
  ({ location }) => location
);
